"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));















































































var _vuex = require("vuex");
var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({ username: 'getUsername' })), components: {}, data: function data() {return { tableData: [], // 列表数据
      // searchData: {
      //   page: 1, // 当前页码
      //   rows: 10 // 页码条数
      // },
      pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', appId: '', platId: '' }, defaultData: { id: '', appId: '', platId: '' }, droplist: [], tableColumns: [{ prop: 'appName', label: '应用ID', isShow: true }, { prop: 'operatorName', label: '操作人员', isShow: true }, { prop: 'updateTime', label: '操作时间', formatter: _formatter.dateFormatter, isShow: true }], rules: { appId: [{ required: true, message: '请选择应用ID', trigger: 'blur' }] }, delIds: '' };}, mounted: function mounted() {var self = this;self.init();self.addData.platId = self.$route.params.parentId;}, methods: { init: function init() {var self = this;self.getData('/api/faPlatRefApp/plat/' + self.$route.params.parentId, self.searchData, function (res) {self.tableData = res;});}, getLanguageList: function getLanguageList() {var self = this;self.getData('/api/faPlatRefApp/canChooseApp/plat/' + self.$route.params.parentId + '?platRefAppId=' + self.addData.id, {}, function (res) {self.droplist = res;});}, onCencal: function onCencal() {this.newadd = false;this.$refs['addForm'].resetFields();},
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faPlatRefApp/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.getLanguageList();
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var data = {
            platId: self.$route.params.parentId,
            appId: self.addData.appId };

          self.postData('/api/faPlatRefApp', data, function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      console.log(item);
      self.addData = {
        id: item.id,
        platId: item.platId,
        appId: item.appId };

      self.getLanguageList();
      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faPlatRefApp/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/configure/currency');
    } } };exports.default = _default;